module.exports = __webpack_public_path__ + "img/courier-pickup.56cc5c7d.svg";